import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { centralizedHost } from "~/Utils";

interface DocumentDetailsResponse {
  id: number;
  title: string;
  title_malay: string;
  title_mandarin: string;
  redirect_url: string;
  published: boolean;
  end_date: string;
  start_date: string;
  sequence: string;
  banner_image: string;
  // banner_body_image: string;
  created_by: string;
  project_airport_id: string;
  last_modified_by: string;
  description_english_1: string;
  description_mandarin_1: string;
  description_malay_1: string;
  terms_condition: string;
  terms_condition_malay: string;
  terms_condition_mandarin: string;
}

const fetchCentralisedPromotionsDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await axios.get(`${centralizedHost}/api/promotions/${id}`);
  return response.data[0];
};

const useCentralisedPromotionsDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["centralizedPromotions", id],
      enabled: false,
      queryFn: () => {
        return fetchCentralisedPromotionsDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useCentralisedPromotionsDetails };
